import {
  UpdateIconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  pn,
  ListContext,
} from "@compass/core";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from '@mui/icons-material/Delete';
import { useList, useRouter } from "hooks";
import { SortObject, SurveyResponseListDto, SurveyResponseListResource } from "generated/openApi";
import { Outlet, useNavigate } from "react-router-dom";
import { ListBeProperty } from "components";
import { publicSurveyPageRoute } from "pages/public-forms/surveys/PublicSurveyPage";
import { useDateTime } from "hooks";
import { surveyResponseStudentPageRoute } from "../SurveyResponseStudent/SurveyResponseStudentPage";

export const SurveyResponseTable = (props: {
  tableContainerRef: React.RefObject<HTMLDivElement>;
  surveyResponses: SurveyResponseListDto[];
  listTotal: number | undefined;
  resource: SurveyResponseListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
}) => {
  const properties = props.resource.properties || [];
  const formatDateTime = useDateTime();
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();

  const navigateSurveyResponseView = (surveyResponse: SurveyResponseListDto) => {
    var route = `/${publicSurveyPageRoute.getPath({
      id: surveyResponse.surveyIdentifier!,
      client: props.resource.tenantName!,
    })}`;
    var queryParams = publicSurveyPageRoute.getOptionalParams?.({
      isViewMode: true,
      surveyResponse: surveyResponse.surveyResponseIdentifier,
    });
    var finalRoute = route + "?" + queryParams;

    window.open(finalRoute, "_blank");
  };

  return (
    <>
      <TableContainer ref={props.tableContainerRef}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                <ListBeProperty
                  listProperty={properties.find((x) => x.propertyName === pn<SurveyResponseListDto>("completedDate"))}
                  sortObjects={props.sortObjects}
                  onChange={(sortObjects) => props.sort(sortObjects)}
                  searchFocused={props.searchFocused}
                />
              </TableCell>
              <TableCell>
                <ListBeProperty
                  listProperty={properties.find((x) => x.propertyName === pn<SurveyResponseListDto>("surveyName"))}
                  sortObjects={props.sortObjects}
                  onChange={(sortObjects) => props.sort(sortObjects)}
                  searchFocused={props.searchFocused}
                />
              </TableCell>
              <TableCell>
                <ListBeProperty
                  listProperty={properties.find((x) => x.propertyName === pn<SurveyResponseListDto>("recipientName"))}
                  sortObjects={props.sortObjects}
                  onChange={(sortObjects) => props.sort(sortObjects)}
                  searchFocused={props.searchFocused}
                />
              </TableCell>

              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.surveyResponses.map((surveyResponse) => (
              <TableRow key={surveyResponse.id} onClick={() => {}}>
                <TableCell>{formatDateTime(surveyResponse.completedDate)}</TableCell>
                <TableCell>{surveyResponse.surveyName}</TableCell>
                <TableCell>{surveyResponse.recipientName}</TableCell>
                <TableCell type="action">
                  <PreviewIcon
                    onClick={() => {
                      navigateSurveyResponseView(surveyResponse);
                    }}
                  />
                  <UpdateIconButton
                    onClick={() =>
                      navigate({
                        pathname: surveyResponseStudentPageRoute.getPath({
                          id: surveyResponse.id,
                          crudMode: "edit",
                          screenType: "dialog",
                          deleting: false,
                        }),
                      })
                    }
                  />
                  <DeleteIcon
                    style={{ color: "red"}}
                    onClick={() => {
                      navigate({
                        pathname: surveyResponseStudentPageRoute.getPath({
                          id: surveyResponse.id,
                          crudMode: "edit",
                          screenType: "dialog",
                          deleting: true
                        }),
                      })
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {matchTemplatePath(surveyResponseStudentPageRoute.templatePath) && <Outlet />}
    </>
  );
};
